<script>
import IconWrapper from './IconWrapper.vue'
import IconWatchmanSvg from '@/assets/img/icons/IconWatchman.svg'

export default {
  name: 'IconWatchman',
  components: {
    IconWrapper
  },
  computed: {
    svg () {
      return IconWatchmanSvg
    }
  }
}
</script>

<template>
  <IconWrapper v-html="svg" class="IconWatchman" />
</template>
